export * from "@/ui/components/typography/TextEyebrow/TextEyebrow";
export * from "@/ui/components/typography/TextEyebrow/TextEyebrow.config";
export * from "@/ui/components/typography/TextEyebrow/TextEyebrow.guards";
